<div class="loading-state">
  <ngx-spinner
    bdColor="#FFFFFF"
    size="large"
    color="#006AFF"
    type="line-scale"
    [fullScreen]="false"
  >
    <p class="loading-text">{{ loading_text }} ...</p>
  </ngx-spinner>
</div>
